import React, { Component } from "react";
import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import ShoppingIcon from "@material-ui/icons/ShoppingCartOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import LocationIcon from "@material-ui/icons/RoomOutlined";
import { nextDeliveryLabel } from "../utils/DateUtils";
import withCustomStyles from "./HeaderPart.style";
import PersonIcon from "@material-ui/icons/PersonOutlineRounded";
import SearchPart from "./SearchPart";
import DrawerPart from "./DrawerPart";
import { withRouter } from "react-router";
import { inject, observer } from "mobx-react";
import AddressesPart from "./AddressesPart";
import classnames from "classnames";
import gtmService from "../services/GTMService";
import { strLimit } from "../utils/HelperUtils";
import { formatItemCount, formatPhone } from "../utils/FormatUtils";
import { getLargeLogo } from "../utils/UrlUtils";
import ExpandIcon from "@material-ui/icons/ExpandMore";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import { GButton } from "./ui";
import Fade from "@material-ui/core/Fade";
import Paper from "@material-ui/core/Paper";
import Collapse from "@material-ui/core/Collapse";
import Popper from "@material-ui/core/Popper";
import MyLocationIcon from "@material-ui/icons/MyLocation";
import { isEasyPaisaMiniApp } from "../utils/AppUtils";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withSnackbar } from "notistack";
import LoadMorePart from "./LoadMorePart";

const initials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map(part => part[0])
    .join("")
    .toUpperCase() || "G";

@inject(["orderStore"])
@inject(["customerStore"])
@inject(["uiStore"])
@inject(["locationStore"])
@inject(["categoriesStore"])
@inject(["allBrandsStore"])
@inject(["searchProductsStore"])
@inject(["globalSettingStore"])
@observer
class HeaderPart extends Component {
  locationRef = React.createRef();

  state = {
    anchorEl: <></>,
    locError: false,
    locDisabled: "",
    expanded: false,
    drawerOpen: false,
    selectManually: false,
    selectedLocation: null,
    locationAccess: false,
    isLoading: false,
    isOverlayClicked: false,
    accountAnchor: null
  };

  openAccountMenu = event => {
    gtmService.pageView("/account-menu");
    this.setState({ accountAnchor: event.currentTarget, expanded: false });
  };

  closeAccountMenu = () => {
    this.setState({ accountAnchor: null });
  };

  handleLogout = () => {
    const { customerStore } = this.props;
    this.closeAccountMenu();
    if (customerStore.isLoggedIn) {
      customerStore.logout();
    }
  };

  componentDidMount() {
    const {
      props: {
        location: { pathname },
        locationStore,
        customerStore
      }
    } = this;
    this.setState({ anchorEl: this.locationRef.current });
    setTimeout(() => {
      if (customerStore.isLoggedIn) {
        locationStore.getAddresses();
      }
    }, 200);
    if (pathname === "/unsubscribe") {
      this.handleUpdateLocation({
        lat: "31.5204",
        lng: "74.3587"
      });
    }
  }

  fetchCategoriesAndBrands = () => {
    const { categoriesStore, allBrandsStore } = this.props;

    categoriesStore.fetch();
    allBrandsStore.fetchLimited(50);
  };

  handleDrawerOpen = () => {
    gtmService.pageView("/side-menu");
    this.setState({
      ...this.state,
      expanded: false,
      drawerOpen: true
    });
  };

  handleDrawerClose = () => {
    this.setState({
      ...this.state,
      drawerOpen: false
    });
  };

  selectLocationEvent = eventName => {
    gtmService.event("User", eventName, window.location.pathname);
  };

  handleLocation = () => {
    this.selectLocationEvent("Set_Auto_Location_Selected");
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        ({ coords }) => {
          if (coords && coords.latitude && coords.longitude) {
            this.setState({
              locationAccess: true
            });
            this.handleUpdateLocation({
              lat: coords.latitude,
              lng: coords.longitude
            });
          }
        },
        () =>
          this.setState({
            locDisabled: "Please allow location from your browser settings"
          })
      );
    }
  };

  toggleExpanded = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  handleUpdateLocation = coords => {
    const {
      props: {
        uiStore,
        customerStore,
        globalSettingStore,
        location: { pathname },
        history
      },
      state: { locError },
      fetchCategoriesAndBrands
    } = this;
    this.setState({ isLoading: true });
    if (pathname === "/checkout") {
      uiStore.setDefaultDeliveryLocation({
        lat: coords.lat,
        lng: coords.lng,
        location: coords.location
      });
      customerStore.fetchVendor(
        undefined,
        () => {
          fetchCategoriesAndBrands();
          this.setState({ isLoading: false });
          history.push("/cart");
        },
        () => {
          this.setState({ isLoading: false });
        }
      );
    }
    if (pathname !== "/checkout") {
      uiStore.setDefaultDeliveryLocation({
        lat: coords.lat,
        lng: coords.lng
      });
      this.setState({
        selectedLocation: coords
      });
      customerStore.fetchVendor(
        undefined,
        data => {
          if (coords.location) {
            this.selectLocationEvent("Set_Manual_Location_Selected");
          }
          if (locError) this.setState({ locError: false });
          uiStore.setDefaultDeliveryLocation({
            lat: coords.lat,
            lng: coords.lng,
            location: data.name
          });
          fetchCategoriesAndBrands();
          this.setState({ isLoading: false });
          globalSettingStore.registerDevice();
        },
        () => {
          this.setState({ locError: true });
          this.setState({ isLoading: false });
        }
      );
    }
  };

  handleSelectManually = value => {
    this.setState({ selectManually: value });
  };

  handleChangeLocation = () => {
    const {
      props: {
        history,
        enqueueSnackbar,
        customerStore,
        locationStore,
        location: { pathname, search }
      }
    } = this;
    if (
      customerStore.isLoggedIn &&
      locationStore.all.length < 1 &&
      locationStore.getAddressesState === "done" &&
      pathname !== "/add-address"
    ) {
      gtmService.event("User", "Location_tapped_from_Home");
      history.push("/add-address?redirect=/");
    }
    if (!customerStore.isLoggedIn && pathname !== "/change-location") {
      history.push(`/change-location?redirect=${pathname}${search}`);
    } else if (locationStore.all.length > 0) {
      gtmService.event(
        "User",
        "Location_bottom_sheet_opened",
        "From_Home_Page"
      );
      this.toggleExpanded();
    }
    if (
      customerStore.isLoggedIn &&
      locationStore.getAddressesState !== "done" &&
      locationStore.all.length === 0
    ) {
      enqueueSnackbar(
        "We couldn't load your saved addresses. Check your connection and try again.",
        {
          variant: "error"
        }
      );
    }
  };

  overlayClicked = () => {
    const {
      state: { isOverlayClicked }
    } = this;
    if (!isOverlayClicked) {
      gtmService.event("User", "Location overlay clicked");
      this.setState({
        isOverlayClicked: true
      });
      setTimeout(() => {
        this.setState({
          isOverlayClicked: false
        });
      }, 300);
    }
  };

  isDefaultLocationAllowedPage = pathname => {
    // untill we are deliverying in single city, allow the browsing with default city selected by default
    return pathname.search("/") === -1;
  };

  render() {
    const {
      props: {
        classes,
        orderStore,
        customerStore: {
          customer,
          isLoggedIn,
          fetchVendorState,
          vendor,
          expressDeliveryStatus
        },
        uiStore,
        locationStore,
        location: { pathname }
      },
      state: {
        drawerOpen,
        anchorEl,
        expanded,
        locError,
        locDisabled,
        selectManually,
        selectedLocation,
        locationAccess,
        isLoading,
        isOverlayClicked,
        accountAnchor
      },
      handleLocation,
      toggleExpanded,
      // handleSelectManually,
      handleChangeLocation,
      overlayClicked,
      isDefaultLocationAllowedPage
    } = this;

    const location =
      uiStore &&
      uiStore.defaultDeliveryLocation &&
      uiStore.defaultDeliveryLocation.location;

    const isDefaultLocation =
      uiStore &&
      uiStore.defaultDeliveryLocation &&
      uiStore.defaultDeliveryLocation.default;

    const googleAddress =
      isLoggedIn &&
      locationStore.currentAddress &&
      locationStore.currentAddress.single_line_address
        ? locationStore.currentAddress.single_line_address
        : isLoggedIn && customer.address !== "N/A"
        ? customer.address
        : (location === "N/A" && vendor.name) || location || "";

    let addressCharLimit = 15;
    if (uiStore.screenWidth >= 375 && uiStore.screenWidth < 800) {
      addressCharLimit = 20;
    } else if (uiStore.screenWidth >= 800) {
      addressCharLimit = 50;
    }

    // Focused / flow pages keep the header quiet (no search)
    const showSearch = !["/change-location", "/profile", "/login"].some(path =>
      pathname.startsWith(path)
    );
    const addressLabel = isDefaultLocation
      ? location
      : strLimit(googleAddress, addressCharLimit);
    const showMembership = !isEasyPaisaMiniApp();
    const eta = addressLabel
      ? nextDeliveryLabel(vendor, expressDeliveryStatus)
      : "";

    return (
      <AppBar position="sticky" className={classes.appBar}>
        <div className={classes.bar}>
          <Link
            to="/"
            aria-label="GrocerApp home"
            className={classes.logoLink}
            onClick={() => this.setState({ expanded: false })}
          >
            <img alt="grocer" className={classes.logo} src={getLargeLogo()} />
          </Link>
          <div ref={this.locationRef} className={classes.locationWrap}>
            <button
              type="button"
              className={classes.locationBtn}
              onClick={handleChangeLocation}
              aria-expanded={expanded}
              aria-label={`Delivery location: ${addressLabel || "not set"}${
                eta ? `, next delivery ${eta}` : ""
              }`}
            >
              <LocationIcon className={classes.pinIcon} aria-hidden="true" />
              <span className={classes.locationText}>
                {addressLabel || "Set delivery location"}
              </span>
              {eta && (
                <>
                  <span className={classes.etaDot} aria-hidden="true">
                    ·
                  </span>
                  <span className={classes.eta}>{eta}</span>
                </>
              )}
              <ExpandIcon
                aria-hidden="true"
                className={classnames(classes.chevron, {
                  [classes.chevronOpen]: expanded
                })}
              />
            </button>
          </div>
          {uiStore.dataLoaded &&
            !isLoggedIn &&
            (!location || isDefaultLocation) &&
            pathname !== "/change-location" &&
            (isDefaultLocationAllowedPage(pathname) || uiStore.showLocPopup) &&
            pathname !== "/unsubscribe" && (
              <Popper
                open
                placement="bottom-start"
                disablePortal={true}
                modifiers={{
                  flip: {
                    enabled: true
                  },
                  preventOverflow: {
                    enabled: true,
                    boundariesElement: "scrollParent"
                  },
                  arrow: {
                    enabled: true,
                    element: anchorEl
                  }
                }}
                anchorEl={anchorEl}
                className={classes.popperUi}
                transition
              >
                {({ TransitionProps }) => (
                  <Fade
                    className={`${classes.popperUi} ${
                      classes.locationModalWrap
                    } ${isOverlayClicked ? "shake-animation" : ""}`}
                    {...TransitionProps}
                  >
                    <Paper elevation={3}>
                      {!isEasyPaisaMiniApp() &&
                        !selectManually &&
                        !locDisabled &&
                        !locError && (
                          <>
                            <Typography variant="subtitle1" gutterBottom>
                              Welcome to GrocerApp.
                            </Typography>
                            <Grid container wrap="nowrap">
                              <Grid item className={classes.marginRight1}>
                                <LocationOnIcon
                                  color="primary"
                                  fontSize="large"
                                />
                              </Grid>
                              <Grid item>
                                <Typography gutterBottom>
                                  Please provide your delivery location to see
                                  products at nearby store.
                                </Typography>
                                <Grid container>
                                  <Grid
                                    className={classnames(
                                      classes.marginTop1,
                                      classes.paddingRight1
                                    )}
                                    xs={12}
                                    sm={6}
                                    item
                                  >
                                    <GButton
                                      fullWidth
                                      variant="outline"
                                      // onClick={handleSelectManually}
                                      onClick={() =>
                                        this.handleUpdateLocation(
                                          uiStore.availableLocations[0]
                                        )
                                      }
                                      // isabled={locationAccess}
                                      disabled={isLoading}
                                    >
                                      Set Lahore
                                      {isLoading && (
                                        <CircularProgress
                                          className={classes.btnLoading}
                                        />
                                      )}
                                    </GButton>
                                  </Grid>
                                  <Grid
                                    className={classes.marginTop1}
                                    xs={12}
                                    sm={6}
                                    item
                                  >
                                    <GButton
                                      fullWidth
                                      onClick={handleLocation}
                                      className={classes.deliveryBtn}
                                      disabled={locationAccess}
                                    >
                                      Set delivery location
                                      {locationAccess && (
                                        <CircularProgress
                                          className={classes.btnLoading}
                                        />
                                      )}
                                    </GButton>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </>
                        )}
                      {(selectManually ||
                        locDisabled ||
                        locError ||
                        isEasyPaisaMiniApp()) && (
                        <>
                          <Grid
                            container
                            direction="column"
                            justify="center"
                            alignItems="center"
                          >
                            {!isEasyPaisaMiniApp() && (
                              <Grid item className={classes.marginBottom1}>
                                <MyLocationIcon
                                  color="primary"
                                  fontSize="large"
                                />
                              </Grid>
                            )}
                            <Grid item>
                              {!selectManually && !locDisabled && (
                                <Typography variant="h6" align={"center"}>
                                  {isEasyPaisaMiniApp()
                                    ? "Welcome to GrocerApp"
                                    : "We are not here yet!"}
                                </Typography>
                              )}
                              {locDisabled && (
                                <Typography variant="h6" align={"center"}>
                                  Location Access Denied!
                                </Typography>
                              )}
                              {selectManually && (
                                <Typography variant="h6" align={"center"}>
                                  Select Manually
                                </Typography>
                              )}
                              <Typography gutterBottom>
                                Please select the city you want to place your
                                order in
                              </Typography>
                            </Grid>
                            <Grid item>
                              <Grid
                                container
                                direction="column"
                                className={classes.marginBottom1}
                              >
                                {uiStore.availableLocations.map(cities => (
                                  <GButton
                                    className={classnames(
                                      classes.marginRight1,
                                      classes.marginBottom1
                                    )}
                                    onClick={() =>
                                      this.handleUpdateLocation(cities)
                                    }
                                    variant="outline"
                                    key={cities.lat}
                                    disabled={fetchVendorState === "fetching"}
                                  >
                                    {cities.location}
                                    {selectedLocation === cities && (
                                      <CircularProgress
                                        className={classes.btnLoading}
                                      />
                                    )}
                                  </GButton>
                                ))}
                              </Grid>
                            </Grid>
                            <Grid item>
                              <Typography
                                paragraph
                                variant="caption"
                                align={"center"}
                                className={classes.marginBottom0}
                              >
                                Currently we only operate in the cities
                                mentioned above. But we are expanding quickly
                                and hopeful will reach other areas soon
                              </Typography>
                            </Grid>
                          </Grid>
                        </>
                      )}
                    </Paper>
                  </Fade>
                )}
              </Popper>
            )}
          {showSearch ? (
            <SearchPart className={classes.search} />
          ) : (
            <span className={classes.spacer} />
          )}
          <Link
            to="/cart"
            className={classes.cartBtn}
            aria-label={`Cart, ${formatItemCount(orderStore.all.size)}`}
            onClick={() => this.setState({ expanded: false })}
          >
            <ShoppingIcon className={classes.cartIcon} aria-hidden="true" />
            {orderStore.all.size > 0 && (
              <span className={classes.cartCount} aria-live="polite">
                {orderStore.all.size}
              </span>
            )}
          </Link>
          {isLoggedIn ? (
            <div className={classes.authActions}>
              <button
                type="button"
                className={classes.accountBtn}
                aria-haspopup="menu"
                aria-controls="account-menu"
                aria-expanded={Boolean(accountAnchor)}
                onClick={this.openAccountMenu}
              >
                <span className={classes.avatar} aria-hidden="true">
                  {initials(customer.name)}
                </span>
                <span>Account</span>
                <ExpandMoreIcon
                  className={classes.chevron}
                  aria-hidden="true"
                />
              </button>
              <Menu
                id="account-menu"
                anchorEl={accountAnchor}
                open={Boolean(accountAnchor)}
                onClose={this.closeAccountMenu}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                classes={{ paper: classes.menuPaper, list: classes.menuList }}
                disableScrollLock
              >
                <li className={classes.menuHead} aria-hidden="true">
                  <span className={classes.menuName}>{customer.name}</span>
                  {customer.phone_number && (
                    <span className={classes.menuPhone}>
                      {formatPhone(customer.phone_number)}
                    </span>
                  )}
                </li>
                <Divider component="li" className={classes.menuDivider} />
                <MenuItem
                  component={Link}
                  to="/myorders"
                  onClick={this.closeAccountMenu}
                  className={classes.menuItem}
                >
                  My orders
                </MenuItem>
                <MenuItem
                  component={Link}
                  to="/saved-locations"
                  onClick={this.closeAccountMenu}
                  className={classes.menuItem}
                >
                  Saved addresses
                </MenuItem>
                <MenuItem
                  component={Link}
                  to={`/profile?redirect=${pathname}`}
                  onClick={this.closeAccountMenu}
                  className={classes.menuItem}
                >
                  Profile
                </MenuItem>
                {showMembership && (
                  <MenuItem
                    component={Link}
                    to="/wallet"
                    onClick={this.closeAccountMenu}
                    className={classes.menuItem}
                  >
                    Wallet
                  </MenuItem>
                )}
                {showMembership && (
                  <MenuItem
                    component={Link}
                    to="/membership"
                    onClick={this.closeAccountMenu}
                    className={classes.menuItem}
                  >
                    Grocer Club
                  </MenuItem>
                )}
                <MenuItem
                  component={Link}
                  to="/faqs"
                  onClick={this.closeAccountMenu}
                  className={classes.menuItem}
                >
                  Help &amp; FAQs
                </MenuItem>
                <Divider component="li" className={classes.menuDivider} />
                <MenuItem
                  onClick={this.handleLogout}
                  className={classnames(classes.menuItem, classes.menuDanger)}
                >
                  Log out
                </MenuItem>
              </Menu>
            </div>
          ) : (
            !isEasyPaisaMiniApp() && (
              <div className={classes.authActions}>
                <Link to="/login" className={classes.loginBtn}>
                  Log in
                </Link>
                <Link to="/login" className={classes.signupBtn}>
                  Sign up
                </Link>
              </div>
            )
          )}
          {/* phones: account entry on the right opens the side menu */}
          <button
            type="button"
            className={classes.phoneAccountBtn}
            onClick={this.handleDrawerOpen}
            aria-haspopup="dialog"
            aria-expanded={drawerOpen}
            aria-label={isLoggedIn ? "Account and menu" : "Log in and menu"}
          >
            {isLoggedIn ? (
              <span
                className={classnames(classes.avatar, classes.avatarSm)}
                aria-hidden="true"
              >
                {initials(customer.name)}
              </span>
            ) : (
              <PersonIcon className={classes.personIcon} aria-hidden="true" />
            )}
          </button>
          <div className={classes.locationDropDown}>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <AddressesPart
                toggleCollapse={() => toggleExpanded()}
                handleVendorChange={coords => this.handleUpdateLocation(coords)}
              />
            </Collapse>
          </div>
        </div>
        {uiStore.dataLoaded &&
          (!location || isDefaultLocation) &&
          pathname !== "/change-location" &&
          (isDefaultLocationAllowedPage(pathname) || uiStore.showLocPopup) &&
          pathname !== "/unsubscribe" && (
            <>
              <Grid
                onClick={overlayClicked}
                className={classes.dimBackground}
              />
              {isLoggedIn && <LoadMorePart className={classes.loader} />}
            </>
          )}
        {expanded && (
          <Grid
            className={classes.dimBackground}
            onClick={() => this.setState({ expanded: false })}
          />
        )}
        <DrawerPart open={drawerOpen} onClose={this.handleDrawerClose} />
      </AppBar>
    );
  }
}

export default withRouter(withSnackbar(withCustomStyles(HeaderPart)));
